<div class="p-4 md:p-6 w-full">

  <!-- Header -->
  <h1 class="text-2xl font-bold text-gray-800 flex items-center">
    <mat-icon style="color: #1C593D; margin-right: 8px;">swap_horiz</mat-icon>
    {{ getTitle() }}
  </h1>

  <!-- View Toggle Tabs -->
  <div class="flex justify-center mt-6">
    <div class="inline-flex rounded-xl overflow-hidden border" style="border-color: #d1d5db;">
      <button (click)="onCrearTransaccionClick()"
        [style.background]="viewType === 'crear Transaccion' ? '#1C593D' : 'white'"
        [style.color]="viewType === 'crear Transaccion' ? 'white' : '#374151'"
        style="display: inline-flex; align-items: center; gap: 6px; padding: 10px 24px; border: none; font-weight: 700; font-size: 0.9rem; cursor: pointer; transition: all 0.2s ease;">
        <mat-icon style="font-size: 18px; width: 18px; height: 18px;"
          [style.color]="viewType === 'crear Transaccion' ? 'white' : '#1C593D'">add_circle</mat-icon>
        Crear Transacción
      </button>
      <button (click)="onHistorialTransaccionesClick()"
        [style.background]="viewType === 'historial Transacciones' ? '#1C593D' : 'white'"
        [style.color]="viewType === 'historial Transacciones' ? 'white' : '#374151'"
        style="display: inline-flex; align-items: center; gap: 6px; padding: 10px 24px; border: none; border-left: 1px solid #d1d5db; font-weight: 700; font-size: 0.9rem; cursor: pointer; transition: all 0.2s ease;">
        <mat-icon style="font-size: 18px; width: 18px; height: 18px;"
          [style.color]="viewType === 'historial Transacciones' ? 'white' : '#1C593D'">history</mat-icon>
        Historial de Transacciones
      </button>
    </div>
  </div>

  <!-- ==================== CREAR TRANSACCION VIEW ==================== -->
  <div *ngIf="viewType === 'crear Transaccion'" class="mt-6">

    <!-- Search Filter Card -->
    <div class="flex justify-center">
      <div class="w-full max-w-4xl bg-white p-6 rounded-xl shadow-lg border border-gray-100">
        <div class="flex items-center gap-2 mb-4">
          <mat-icon style="color: #1C593D; font-size: 20px; width: 20px; height: 20px;">filter_list</mat-icon>
          <span class="text-sm font-semibold" style="color: #1e5a3f;">Buscar usuario</span>
        </div>
        <div class="flex flex-col sm:flex-row items-end gap-3">
          <mat-form-field appearance="outline" class="modern-field flex-1 w-full">
            <mat-label>Tipo de búsqueda</mat-label>
            <mat-icon matPrefix style="color: #6b7280;">category</mat-icon>
            <mat-select required [(ngModel)]="selectedFilter">
              <mat-option>Seleccione un filtro</mat-option>
              <mat-option *ngFor="let filter of filters" [value]="filter">
                {{ filterDescriptions[filter] }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="outline" class="modern-field flex-1 w-full">
            <mat-label>Valor de búsqueda</mat-label>
            <mat-icon matPrefix style="color: #6b7280;">search</mat-icon>
            <input matInput type="text" [(ngModel)]="searchValue">
            <button *ngIf="searchValue" matSuffix (click)="searchValue = ''"
              style="display: inline-flex; align-items: center; justify-content: center; width: 24px; height: 24px; border: none; background: transparent; cursor: pointer;">
              <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #9ca3af;">close</mat-icon>
            </button>
          </mat-form-field>
          <button type="button" (click)="search()"
            style="display: inline-flex; align-items: center; gap: 8px; padding: 10px 36px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.9rem; cursor: pointer; transition: background 0.2s ease; white-space: nowrap;"
            onmouseover="this.style.background='#059669'"
            onmouseout="this.style.background='#1C593D'">
            <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white;">search</mat-icon>
            Buscar
          </button>
        </div>
      </div>
    </div>

    <!-- Desktop Users Table -->
    <div class="hidden lg:block mt-4 overflow-x-auto rounded-xl shadow-lg border border-gray-100" *ngIf="dataSource">
      <table mat-table [dataSource]="dataSource" matSort (matSortChange)="sortData($event)" class="w-full">

        <ng-container matColumnDef="idUsuario">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>ID</th>
          <td mat-cell *matCellDef="let row">
            <span class="font-mono font-bold bg-green-100 text-green-800 px-2 py-0.5 rounded-full text-xs">
              #{{ row.usuarioId }}
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="nombre">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Nombre</th>
          <td mat-cell *matCellDef="let row" class="text-xs font-semibold" style="color: #374151;">
            {{ row.nombre }} {{ row.apellidos }}
          </td>
        </ng-container>

        <ng-container matColumnDef="documento">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Documento</th>
          <td mat-cell *matCellDef="let row" class="text-xs font-mono" style="color: #374151;">
            {{ row.numeroId }}
          </td>
        </ng-container>

        <ng-container matColumnDef="email">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Email</th>
          <td mat-cell *matCellDef="let row" class="text-xs" style="color: #2563eb;">
            {{ row.email }}
          </td>
        </ng-container>

        <ng-container matColumnDef="acciones" stickyEnd>
          <th mat-header-cell *matHeaderCellDef>Crear</th>
          <td mat-cell *matCellDef="let row">
            <div style="display: flex; gap: 4px; justify-content: center;">
              <button title="Crear transacción" (click)="openCreateFormDialog(row.usuarioId, row.nombre + ' ' + row.apellidos)"
                style="display: inline-flex; align-items: center; justify-content: center; width: 30px; height: 30px; border: 1px solid #bbf7d0; border-radius: 6px; background: #f0fdf4; cursor: pointer;">
                <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #16a34a;">note_add</mat-icon>
              </button>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </div>

    <!-- Mobile Users Cards -->
    <div class="lg:hidden mt-4 space-y-3" *ngIf="dataSource">
      <div *ngFor="let row of dataSource.data"
        class="bg-white rounded-xl shadow-md border border-gray-200 p-4">
        <div class="flex items-center justify-between mb-3">
          <span class="font-mono font-bold bg-green-100 text-green-800 px-2 py-0.5 rounded-full text-xs">
            #{{ row.usuarioId }}
          </span>
          <button title="Crear transacción" (click)="openCreateFormDialog(row.usuarioId, row.nombre + ' ' + row.apellidos)"
            style="display: inline-flex; align-items: center; gap: 4px; padding: 6px 12px; border: 1px solid #bbf7d0; border-radius: 8px; background: #f0fdf4; cursor: pointer; font-size: 0.75rem; font-weight: 600; color: #16a34a;">
            <mat-icon style="font-size: 14px; width: 14px; height: 14px; color: #16a34a;">note_add</mat-icon>
            Crear
          </button>
        </div>
        <div class="grid grid-cols-1 gap-1 text-xs">
          <div class="flex items-center gap-1">
            <mat-icon style="font-size: 14px; width: 14px; height: 14px; color: #6b7280;">person</mat-icon>
            <span class="font-semibold" style="color: #374151;">{{ row.nombre }} {{ row.apellidos }}</span>
          </div>
          <div class="flex items-center gap-1">
            <mat-icon style="font-size: 14px; width: 14px; height: 14px; color: #6b7280;">badge</mat-icon>
            <span class="font-mono" style="color: #374151;">{{ row.numeroId }}</span>
          </div>
          <div class="flex items-center gap-1">
            <mat-icon style="font-size: 14px; width: 14px; height: 14px; color: #6b7280;">email</mat-icon>
            <span style="color: #2563eb;">{{ row.email }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- ==================== HISTORIAL VIEW ==================== -->
  <div *ngIf="viewType === 'historial Transacciones'" class="mt-6">

    <!-- Sub-filter buttons -->
    <div class="flex justify-center gap-2 mb-4 flex-wrap">
      <button (click)="onOrdenesAbiertasClick()"
        [style.background]="historialFilter === 'ABIERTAS' ? '#1C593D' : 'white'"
        [style.color]="historialFilter === 'ABIERTAS' ? 'white' : '#374151'"
        [style.border]="historialFilter === 'ABIERTAS' ? '1px solid #1C593D' : '1px solid #d1d5db'"
        style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 20px; border-radius: 10px; font-weight: 600; font-size: 0.85rem; cursor: pointer; transition: all 0.2s ease;">
        <mat-icon style="font-size: 16px; width: 16px; height: 16px;"
          [style.color]="historialFilter === 'ABIERTAS' ? 'white' : '#16a34a'">lock_open</mat-icon>
        Abiertas
      </button>
      <button (click)="onOrdenesCerradasClick()"
        [style.background]="historialFilter === 'CERRADAS' ? '#1C593D' : 'white'"
        [style.color]="historialFilter === 'CERRADAS' ? 'white' : '#374151'"
        [style.border]="historialFilter === 'CERRADAS' ? '1px solid #1C593D' : '1px solid #d1d5db'"
        style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 20px; border-radius: 10px; font-weight: 600; font-size: 0.85rem; cursor: pointer; transition: all 0.2s ease;">
        <mat-icon style="font-size: 16px; width: 16px; height: 16px;"
          [style.color]="historialFilter === 'CERRADAS' ? 'white' : '#dc2626'">lock</mat-icon>
        Cerradas
      </button>
      <button (click)="onOrdenesTodasClick()"
        [style.background]="historialFilter === 'TODAS' ? '#1C593D' : 'white'"
        [style.color]="historialFilter === 'TODAS' ? 'white' : '#374151'"
        [style.border]="historialFilter === 'TODAS' ? '1px solid #1C593D' : '1px solid #d1d5db'"
        style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 20px; border-radius: 10px; font-weight: 600; font-size: 0.85rem; cursor: pointer; transition: all 0.2s ease;">
        <mat-icon style="font-size: 16px; width: 16px; height: 16px;"
          [style.color]="historialFilter === 'TODAS' ? 'white' : '#1C593D'">list</mat-icon>
        Todas
      </button>
    </div>

    <!-- Date Filter Card -->
    <div class="flex justify-center mb-4">
      <div class="w-full max-w-4xl bg-white p-6 rounded-xl shadow-lg border border-gray-100">
        <div class="flex items-center gap-2 mb-4">
          <mat-icon style="color: #1C593D; font-size: 20px; width: 20px; height: 20px;">date_range</mat-icon>
          <span class="text-sm font-semibold" style="color: #1e5a3f;">Filtrar por fecha</span>
        </div>
        <form [formGroup]="range" (ngSubmit)="onDateFilterChange()" *ngIf="range">
          <div class="flex flex-col sm:flex-row items-end gap-3">
            <mat-form-field appearance="outline" class="modern-field flex-1 w-full">
              <mat-label>Rango de fechas</mat-label>
              <mat-date-range-input [formGroup]="range" [rangePicker]="picker">
                <input matStartDate formControlName="start" placeholder="Inicio">
                <input matEndDate formControlName="end" placeholder="Fin">
              </mat-date-range-input>
              <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-date-range-picker #picker></mat-date-range-picker>
            </mat-form-field>
            <mat-form-field appearance="outline" class="modern-field flex-1 w-full">
              <mat-label>Tipo de fecha</mat-label>
              <mat-icon matPrefix style="color: #6b7280;">event</mat-icon>
              <mat-select formControlName="fechaTypeSelected" placeholder="Seleccione fecha">
                <mat-option *ngFor="let filter of filtersDates" [value]="filter">
                  {{ filtersDate[filter] }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <button type="submit"
              style="display: inline-flex; align-items: center; gap: 8px; padding: 10px 36px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.9rem; cursor: pointer; transition: background 0.2s ease; white-space: nowrap;"
              onmouseover="this.style.background='#059669'"
              onmouseout="this.style.background='#1C593D'">
              <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white;">search</mat-icon>
              Buscar
            </button>
          </div>
        </form>
      </div>
    </div>

    <!-- Paginator -->
    <div class="flex justify-center">
      <mat-paginator #paginator
        class="demo-paginator"
        (page)="onPageChange($event)"
        [length]="totalItems"
        [pageSize]="pageSize"
        [disabled]="false"
        [showFirstLastButtons]="true"
        [pageSizeOptions]="[5, 10, 25, 50, 100]"
        [hidePageSize]="false"
        [pageIndex]="currentPage - 1"
        aria-label="Select page">
      </mat-paginator>
    </div>

    <!-- Desktop History Table -->
    <div class="hidden lg:block mt-4 overflow-x-auto rounded-xl shadow-lg border border-gray-100" *ngIf="dataSourceHistorial">
      <table mat-table [dataSource]="dataSourceHistorial" matSort (matSortChange)="sortDataHistory($event)" class="w-full">

        <ng-container matColumnDef="estado">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Estado</th>
          <td mat-cell *matCellDef="let row">
            <span class="px-2 py-1 inline-flex text-xs leading-5 font-bold rounded-full"
              [style.background]="getEstadoBg(row.estado)"
              [style.color]="getEstadoColor(row.estado)">
              {{ getEstadoLabel(row.estado) }}
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="nombre">
          <th mat-header-cell *matHeaderCellDef>Nombre</th>
          <td mat-cell *matCellDef="let row" class="text-xs font-semibold" style="color: #374151;">
            {{ getUserName(row.usuarioId) }}
          </td>
        </ng-container>

        <ng-container matColumnDef="usuarioId">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Usuario ID</th>
          <td mat-cell *matCellDef="let row">
            <span class="font-mono font-bold bg-green-100 text-green-800 px-2 py-0.5 rounded-full text-xs">
              {{ row.usuarioId }}
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="operatorId">
          <th mat-header-cell *matHeaderCellDef>Operador</th>
          <td mat-cell *matCellDef="let row" class="text-xs" style="color: #374151;">
            {{ row.operatorId }}
          </td>
        </ng-container>

        <ng-container matColumnDef="totalEnvio">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Monto Promesa</th>
          <td mat-cell *matCellDef="let row" class="text-xs font-bold" style="color: #1e5a3f;">
            {{ formatCurrency(row.totalEnvio) }}
          </td>
        </ng-container>

        <ng-container matColumnDef="totalDest">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Total Destino</th>
          <td mat-cell *matCellDef="let row" class="text-xs font-bold" style="color: #1e5a3f;">
            {{ formatCurrency(row.totalDest) }}
          </td>
        </ng-container>

        <ng-container matColumnDef="monedaLocal">
          <th mat-header-cell *matHeaderCellDef>M. Local</th>
          <td mat-cell *matCellDef="let row" class="text-xs" style="color: #374151;">
            {{ row.monedaLocal }}
          </td>
        </ng-container>

        <ng-container matColumnDef="monedaDestino">
          <th mat-header-cell *matHeaderCellDef>M. Destino</th>
          <td mat-cell *matCellDef="let row" class="text-xs" style="color: #374151;">
            {{ row.monedaDestino }}
          </td>
        </ng-container>

        <ng-container matColumnDef="valorPagado">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Valor Pagado</th>
          <td mat-cell *matCellDef="let row" class="text-xs font-bold" style="color: #1e5a3f;">
            {{ formatCurrency(row.valorPagado) }}
          </td>
        </ng-container>

        <ng-container matColumnDef="tasa">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Tasa</th>
          <td mat-cell *matCellDef="let row" class="text-xs font-bold" style="color: #7c3aed;">
            {{ row.tasa }}
          </td>
        </ng-container>

        <ng-container matColumnDef="walletTrx">
          <th mat-header-cell *matHeaderCellDef>Wallet</th>
          <td mat-cell *matCellDef="let row" class="text-xs font-mono" style="color: #2563eb; max-width: 150px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
            {{ row.walletTrx }}
          </td>
        </ng-container>

        <ng-container matColumnDef="fechaCreacion">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>F. Creación</th>
          <td mat-cell *matCellDef="let row" class="text-xs" style="color: #374151;">
            {{ formatUtcDate(row.fechaCreacion) }}
          </td>
        </ng-container>

        <ng-container matColumnDef="fechaFin">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>F. Cierre</th>
          <td mat-cell *matCellDef="let row" class="text-xs" style="color: #374151;">
            {{ row.fechaFin ? formatUtcDate(row.fechaFin) : '' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="fechaActualizacion">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>F. Actualización</th>
          <td mat-cell *matCellDef="let row" class="text-xs" style="color: #374151;">
            {{ formatUtcDate(row.fechaActualizacion) }}
          </td>
        </ng-container>

        <ng-container matColumnDef="id">
          <th mat-header-cell *matHeaderCellDef>ID Orden</th>
          <td mat-cell *matCellDef="let row">
            <span class="font-mono font-bold bg-green-100 text-green-800 px-2 py-0.5 rounded-full text-xs">
              {{ row.id }}
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="acciones" stickyEnd>
          <th mat-header-cell *matHeaderCellDef>Acciones</th>
          <td mat-cell *matCellDef="let row">
            <div style="display: flex; gap: 4px; justify-content: center; flex-wrap: wrap;">
              <button title="Abrir orden" (click)="updateManualTransactionStatus(row, 'ABIERTA')"
                [disabled]="row.estado === 'ABIERTA'"
                [style.opacity]="row.estado === 'ABIERTA' ? '0.4' : '1'"
                style="display: inline-flex; align-items: center; justify-content: center; width: 30px; height: 30px; border: 1px solid #bbf7d0; border-radius: 6px; background: #f0fdf4; cursor: pointer;">
                <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #16a34a;">lock_open</mat-icon>
              </button>
              <button title="Cerrar orden" (click)="updateManualTransactionStatus(row, 'CERRADA')"
                [disabled]="row.estado === 'CERRADA'"
                [style.opacity]="row.estado === 'CERRADA' ? '0.4' : '1'"
                style="display: inline-flex; align-items: center; justify-content: center; width: 30px; height: 30px; border: 1px solid #fecaca; border-radius: 6px; background: #fef2f2; cursor: pointer;">
                <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #dc2626;">lock</mat-icon>
              </button>
              <button title="Eliminar" (click)="RemoveUnnecesaryTransaction(row)"
                [disabled]="ValidateTransaction(row)"
                [style.opacity]="ValidateTransaction(row) ? '0.4' : '1'"
                style="display: inline-flex; align-items: center; justify-content: center; width: 30px; height: 30px; border: 1px solid #fecaca; border-radius: 6px; background: #fef2f2; cursor: pointer;">
                <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #dc2626;">delete</mat-icon>
              </button>
              <button title="Ver historial" (click)="openHistoryFormDialog(row.id, row.walletTrx)"
                style="display: inline-flex; align-items: center; justify-content: center; width: 30px; height: 30px; border: 1px solid #d1d5db; border-radius: 6px; background: white; cursor: pointer;">
                <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #1C593D;">search</mat-icon>
              </button>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumnsHistorial"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumnsHistorial;"></tr>
      </table>
    </div>

    <!-- Mobile History Cards -->
    <div class="lg:hidden mt-4 space-y-3" *ngIf="dataSourceHistorial">
      <div *ngFor="let row of dataSourceHistorial.data"
        class="bg-white rounded-xl shadow-md overflow-hidden transition-all duration-200"
        [style.border]="expandedHistoryCardId === row.id ? '2px solid #1C593D' : '1px solid #e5e7eb'">

        <!-- Card Header -->
        <div class="p-3 cursor-pointer"
          (click)="toggleHistoryCard(row.id)"
          [style.background]="expandedHistoryCardId === row.id ? '#f0fdf4' : 'white'">
          <div class="flex items-center justify-between mb-2">
            <div class="flex items-center gap-2">
              <span class="px-2 py-0.5 inline-flex text-xs leading-5 font-bold rounded-full shrink-0"
                [style.background]="getEstadoBg(row.estado)"
                [style.color]="getEstadoColor(row.estado)">
                {{ getEstadoLabel(row.estado) }}
              </span>
              <span class="text-xs font-semibold truncate" style="color: #374151;">
                {{ getUserName(row.usuarioId) }}
              </span>
            </div>
            <div class="flex items-center gap-2 shrink-0">
              <span class="text-sm font-bold" style="color: #1e5a3f;">
                {{ formatCurrency(row.totalEnvio) }}
              </span>
              <mat-icon style="color: #6b7280; transition: transform 0.2s ease;"
                [style.transform]="expandedHistoryCardId === row.id ? 'rotate(180deg)' : 'rotate(0)'">
                expand_more
              </mat-icon>
            </div>
          </div>
          <span class="font-mono font-bold bg-green-100 text-green-800 px-2 py-1 rounded-lg text-xs break-all" style="display: block;">
            #{{ row.id }}
          </span>
        </div>

        <!-- Card Body -->
        <div *ngIf="expandedHistoryCardId === row.id" class="px-3 pb-3">
          <div class="grid grid-cols-2 gap-2 text-xs mb-3">
            <div>
              <span style="color: #6b7280; font-weight: 600;">Usuario ID</span>
              <p class="font-mono font-bold" style="color: #374151;">{{ row.usuarioId }}</p>
            </div>
            <div>
              <span style="color: #6b7280; font-weight: 600;">Operador</span>
              <p style="color: #374151; font-weight: 500;">{{ row.operatorId }}</p>
            </div>
            <div>
              <span style="color: #6b7280; font-weight: 600;">Monto Promesa</span>
              <p class="font-bold" style="color: #1e5a3f;">{{ formatCurrency(row.totalEnvio) }}</p>
            </div>
            <div>
              <span style="color: #6b7280; font-weight: 600;">Total Destino</span>
              <p class="font-bold" style="color: #1e5a3f;">{{ formatCurrency(row.totalDest) }}</p>
            </div>
            <div>
              <span style="color: #6b7280; font-weight: 600;">Moneda Local</span>
              <p style="color: #374151; font-weight: 500;">{{ row.monedaLocal }}</p>
            </div>
            <div>
              <span style="color: #6b7280; font-weight: 600;">Moneda Destino</span>
              <p style="color: #374151; font-weight: 500;">{{ row.monedaDestino }}</p>
            </div>
            <div>
              <span style="color: #6b7280; font-weight: 600;">Valor Pagado</span>
              <p class="font-bold" style="color: #1e5a3f;">{{ formatCurrency(row.valorPagado) }}</p>
            </div>
            <div>
              <span style="color: #6b7280; font-weight: 600;">Tasa</span>
              <p class="font-bold" style="color: #7c3aed;">{{ row.tasa }}</p>
            </div>
            <div class="col-span-2">
              <span style="color: #6b7280; font-weight: 600;">Wallet</span>
              <p class="font-mono text-xs break-all" style="color: #2563eb;">{{ row.walletTrx }}</p>
            </div>
            <div>
              <span style="color: #6b7280; font-weight: 600;">F. Creación</span>
              <p style="color: #374151; font-weight: 500;">{{ formatUtcDate(row.fechaCreacion) }}</p>
            </div>
            <div>
              <span style="color: #6b7280; font-weight: 600;">F. Cierre</span>
              <p style="color: #374151; font-weight: 500;">{{ row.fechaFin ? formatUtcDate(row.fechaFin) : '-' }}</p>
            </div>
            <div class="col-span-2">
              <span style="color: #6b7280; font-weight: 600;">F. Actualización</span>
              <p style="color: #374151; font-weight: 500;">{{ formatUtcDate(row.fechaActualizacion) }}</p>
            </div>
          </div>

          <!-- Actions -->
          <div class="flex gap-2 pt-2 border-t border-gray-100">
            <button (click)="updateManualTransactionStatus(row, 'ABIERTA'); $event.stopPropagation()" class="flex-1"
              [disabled]="row.estado === 'ABIERTA'"
              [style.opacity]="row.estado === 'ABIERTA' ? '0.4' : '1'"
              style="display: inline-flex; align-items: center; justify-content: center; gap: 4px; padding: 8px; border: 1px solid #bbf7d0; border-radius: 8px; background: #f0fdf4; cursor: pointer; font-size: 0.75rem; font-weight: 600; color: #16a34a;">
              <mat-icon style="font-size: 14px; width: 14px; height: 14px; color: #16a34a;">lock_open</mat-icon>
              Abrir
            </button>
            <button (click)="updateManualTransactionStatus(row, 'CERRADA'); $event.stopPropagation()" class="flex-1"
              [disabled]="row.estado === 'CERRADA'"
              [style.opacity]="row.estado === 'CERRADA' ? '0.4' : '1'"
              style="display: inline-flex; align-items: center; justify-content: center; gap: 4px; padding: 8px; border: 1px solid #fecaca; border-radius: 8px; background: #fef2f2; cursor: pointer; font-size: 0.75rem; font-weight: 600; color: #dc2626;">
              <mat-icon style="font-size: 14px; width: 14px; height: 14px; color: #dc2626;">lock</mat-icon>
              Cerrar
            </button>
            <button (click)="RemoveUnnecesaryTransaction(row); $event.stopPropagation()" class="flex-1"
              [disabled]="ValidateTransaction(row)"
              [style.opacity]="ValidateTransaction(row) ? '0.4' : '1'"
              style="display: inline-flex; align-items: center; justify-content: center; gap: 4px; padding: 8px; border: 1px solid #fecaca; border-radius: 8px; background: #fef2f2; cursor: pointer; font-size: 0.75rem; font-weight: 600; color: #dc2626;">
              <mat-icon style="font-size: 14px; width: 14px; height: 14px; color: #dc2626;">delete</mat-icon>
              Eliminar
            </button>
            <button (click)="openHistoryFormDialog(row.id, row.walletTrx); $event.stopPropagation()" class="flex-1"
              style="display: inline-flex; align-items: center; justify-content: center; gap: 4px; padding: 8px; border: 1px solid #d1d5db; border-radius: 8px; background: white; cursor: pointer; font-size: 0.75rem; font-weight: 600; color: #1C593D;">
              <mat-icon style="font-size: 14px; width: 14px; height: 14px; color: #1C593D;">search</mat-icon>
              Historial
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>
